<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_rule.jpeg')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          プロモーション一般利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2026年10月12日
        </h2>

        <h3 class="terms-title">
          1. 利用規約と条件
        </h3>
        <h4 class="terms-subtitle">
          1.1 本規約の適用および同意
        </h4>
        <p class="terms-clause">
          1.1.1&#12288;勝WIN（以下「当サイト」といいます）にご登録いただくお客様は、本プロモーション一般利用規約（以下「本規約」といいます）に同意いただく必要があります。本規約および本規約において明示的に参照される文書は、当サイトとお客様との間における完全な合意を構成し、契約関係を規定します。
        </p>
        <p class="terms-clause">
          1.1.2&#12288;当サイトをご利用になる前に、必ず本規約をお読みいただき、ご理解のうえご利用ください。万が一、本規約に同意いただけない場合は、当サイトの利用をお控えください。
        </p>
        <p class="terms-clause">
          1.1.3&#12288;各種プロモーションの詳細は、告知またはプロモーションページ内で明示いたします。お客様がプロモーションに参加した時点で、本規約および当該プロモーションに適用される各プロモーションの規約に同意したものとみなします。
        </p>
        <h4 class="terms-subtitle">
          1.2 各プロモーションの規約
        </h4>
        <p class="terms-clause">
          1.2.1&#12288;各プロモーションには、本規約に加え、当該プロモーションに固有の条件を定める各プロモーションの規約が適用されます。
        </p>
        <p class="terms-clause">
          1.2.2&#12288;本規約と各プロモーションの規約の内容が異なる場合は、各プロモーションの規約が優先して適用されます。
        </p>
        <p class="terms-clause">
          1.2.3&#12288;各プロモーションの規約に定めのない事項については、本規約が適用されます。
        </p>
        <h4 class="terms-subtitle">
          1.3 当サイト利用規約との関係
        </h4>
        <p class="terms-clause">
          1.3.1&#12288;本規約は、当サイトの利用規約を補足するものです。プロモーションに関連する行為については、当該行為に使用された資金が現金ウォレットの残高であるか、BONUSウォレットの残高であるかを問わず、本規約、当サイトの利用規約および各プロモーションの規約が適用されます。
        </p>
        <p class="terms-clause">
          1.3.2&#12288;当サイトの利用規約、本規約および各プロモーションの規約の内容が異なる場合、当該プロモーションに関する事項については、各プロモーションの規約、本規約、当サイトの利用規約の順に優先して適用されます。
        </p>

        <h3 class="terms-title">
          2. ウォレット
        </h3>
        <h4 class="terms-subtitle">
          2.1 ウォレットの定義
        </h4>
        <p class="terms-clause">
          2.1.1&#12288;「現金ウォレット」とは、JPYウォレットおよび当サイトが対応する各種仮想通貨ウォレットの総称をいいます。現金ウォレットには、入金された資金のほか、キャッシュバック、入金ボーナス（混合型）その他各プロモーションの規約に基づき付与される資金が反映される場合があります。
        </p>
        <p class="terms-clause">
          2.1.2&#12288;「BONUSウォレット」とは、当サイトが指定するプロモーションまたは特典により付与されるボーナスおよび当該ボーナスから生じた勝利金を管理するためのボーナス専用ウォレットをいいます。BONUSウォレットの残高は直接出金できず、所定の賭け条件を達成することにより現金ウォレットの出金可能残高へ変換されます。
        </p>
        <p class="terms-clause">
          2.1.3&#12288;BONUSウォレット内のボーナス残高および勝利金には、賭け条件の達成状況にかかわらず、当該資金がBONUSウォレット内に存在する限り、5.1、7.2および8.2に定める賭け条件への反映率、禁止ゲームおよびベット額上限その他のBONUSウォレットに関するすべての条件および制限が適用されます。
        </p>
        <h4 class="terms-subtitle">
          2.2 ウォレット振替
        </h4>
        <p class="terms-clause">
          2.2.1&#12288;適用されるすべての賭け条件を達成した資金は、当該資金が入金元本、ボーナスまたは勝利金のいずれに由来するかを問わず、当サイトが提供するウォレット振替機能を通じて、対応する現金ウォレット間で振替を行うことができます。
        </p>
        <p class="terms-clause">
          2.2.2&#12288;JPYウォレットから仮想通貨ウォレットへの振替および交換、ならびに異なる仮想通貨ウォレット間の振替および交換は可能です。
        </p>
        <p class="terms-clause">
          2.2.3&#12288;仮想通貨ウォレットからJPYウォレットへの振替および交換はできません。
        </p>
        <p class="terms-clause">
          2.2.4&#12288;本項に定めるウォレット振替は、現金ウォレットへの入金または現金ウォレットからの出金には該当せず、BONUSウォレット内のボーナス残高および勝利金が失効または削除される原因とはなりません。
        </p>

        <h3 class="terms-title">
          3. ボーナス
        </h3>
        <h4 class="terms-subtitle">
          3.1 ボーナスの定義
        </h4>
        <p class="terms-clause">
          3.1.1&#12288;「ボーナス」とは、各プロモーションの規約に基づきお客様に付与される資金またはその相当額をいいます。ボーナスの付与先、利用方法、賭け条件、出金可否その他の取扱いは、本規約および各プロモーションの規約に定めるところによります。
        </p>
        <h4 class="terms-subtitle">
          3.2 ボーナス等の種類および類型
        </h4>
        <p class="terms-clause">
          3.2.1&#12288;「特典ボーナス」とは、入金を条件とせず、登録特典、誕生日、会員ランクの昇格その他のプロモーションまたは特典により、BONUSウォレットへ直接付与されるボーナスをいいます。
        </p>
        <p class="terms-clause">
          3.2.2&#12288;「キャッシュボーナス」とは、当サイトの特定のプロモーションにおいて、指定された現金ウォレットへ付与されるボーナスをいいます。キャッシュボーナスには、キャッシュバックその他各プロモーションの規約に基づき現金ウォレットへ付与されるボーナスが含まれます。
        </p>
        <p class="terms-clause">
          3.2.3&#12288;「フリースピン」とは、当サイトの各種プロモーションにおいて付与される、特定のスロットで無料で利用できるスピンをいいます。
        </p>
        <p class="terms-clause">
          3.2.4&#12288;「入金ボーナス（混合型）」とは、入金額およびこれに伴い付与されるボーナスが、同一の指定された現金ウォレットに反映される形式をいいます。賭け条件の算定基礎および倍率、対象ゲーム、禁止・除外ゲームならびにベット額上限は、各プロモーションの規約に定めるものとします。
        </p>
        <p class="terms-clause">
          3.2.5&#12288;「入金ボーナス（分離型）」とは、入金額が現金ウォレットに反映され、これに伴い付与されるボーナスがBONUSウォレットに反映される形式をいいます。現金ウォレットに反映された入金額には、4.1.2に定める賭け条件が適用されます。当該入金額には、BONUSウォレットに関する賭け条件への反映率、禁止ゲーム、ベット額上限その他の制限は適用されません。一方、BONUSウォレットに反映されたボーナスには、BONUSウォレットに関するすべての条件および制限が適用されます。それぞれの賭け条件は、ウォレットごとに独立して計算されます。
        </p>

        <h3 class="terms-title">
          4. 賭け条件
        </h3>
        <h4 class="terms-subtitle">
          4.1 賭け条件の定義および適用
        </h4>
        <p class="terms-clause">
          4.1.1&#12288;「賭け条件」とは、ボーナスを現金ウォレットの出金可能残高へ変換するため、または現金ウォレットに入金された資金を出金可能にするために、お客様が当該入金額またはボーナス額に対して所定の倍率でベットを行う必要がある条件をいいます。
        </p>
        <p class="terms-clause">
          4.1.2&#12288;各プロモーションの規約に別段の定めがない限り、現金ウォレットに入金された入金元本には、入金額の2倍の賭け条件が適用されます。
        </p>
        <p class="terms-clause">
          4.1.3&#12288;各ボーナスに適用される賭け条件の倍率および詳細は、当該プロモーションページまたはオファーメールに掲載される各プロモーションの規約に明示されます。
        </p>
        <h4 class="terms-subtitle">
          4.2 ボーナス獲得後の取扱い
        </h4>
        <p class="terms-clause">
          4.2.1&#12288;ボーナス獲得後は所定の賭け条件を達成するまで、ボーナスから得られたすべての勝利金は保留状態となります。お客様は、当該ボーナスを取り消し、放棄し、または当該勝利金を出金することはできません。
        </p>
        <h4 class="terms-subtitle">
          4.3 ウォレット別計算ならびに入金時およびボーナス反映時の取扱い
        </h4>
        <p class="terms-clause">
          4.3.1&#12288;現金ウォレットおよびBONUSウォレットの賭け条件は、ウォレットごとに独立して計算されます。
        </p>
        <p class="terms-clause">
          4.3.2&#12288;ボーナスの利用有無にかかわらず、新たな入金が反映される直前における対象となる現金ウォレットの残高が100円相当額未満である場合、当該現金ウォレットに残る未消化の古い賭け条件は自動的に消滅します。
        </p>
        <p class="terms-clause">
          4.3.3&#12288;ボーナスの利用有無にかかわらず、新たな入金が反映される直前における対象となる現金ウォレットの残高が100円相当額以上である場合、未消化の賭け条件は消滅せず、当該現金ウォレットにおいて累積して適用されます。
        </p>
        <p class="terms-clause">
          4.3.4&#12288;新たなボーナスが反映される直前における対象となるBONUSウォレットの残高が100円未満である場合、当該BONUSウォレットに残る未消化の古い賭け条件は自動的に消滅します。
        </p>
        <p class="terms-clause">
          4.3.5&#12288;新たなボーナスが反映される直前における対象となるBONUSウォレットの残高が100円以上である場合、当該BONUSウォレットに残る未消化の賭け条件は消滅せず、新たなボーナスに設定された賭け条件と合算され、累積して適用されます。
        </p>
        <h4 class="terms-subtitle">
          4.4 進捗確認および無効時の取扱い
        </h4>
        <p class="terms-clause">
          4.4.1&#12288;お客様は賭け条件の進行状況をアカウント内で随時ご確認いただけます。賭け条件の管理およびその達成状況の把握は、すべてお客様ご自身の責任となります。なお、過去に受け取ったボーナスに付随する賭け条件が未消化のまま引き継がれていた場合や、お客様がそれを認識していない状態でプレイを行った場合であっても、当サイトは、これに起因するいかなる損失または不利益についても一切の責任を負いません。
        </p>
        <p class="terms-clause">
          4.4.2&#12288;ボーナスが無効となった場合、当該ボーナスに関連する勝利金を含むすべてのボーナス残高はアカウントから削除されます。
        </p>

        <h3 class="terms-title">
          5. 賭け条件への反映率
        </h3>
        <h4 class="terms-subtitle">
          5.1 BONUSウォレット
        </h4>
        <p class="terms-clause">
          5.1.1&#12288;BONUSウォレット内の残高を利用してベットする場合、各ゲームのベット額は、賭け条件に対して次の割合で反映されます。
        </p>
        <p class="terms-clause terms-clause-item">
          5.1.1(a)&#12288;スロットゲーム：100％
        </p>
        <p class="terms-clause terms-clause-item">
          5.1.1(b)&#12288;ライブカジノ：20％
        </p>
        <h4 class="terms-subtitle">
          5.2 現金ウォレット
        </h4>
        <p class="terms-clause">
          5.2.1&#12288;各プロモーションの規約に別段の定めがない限り、現金ウォレットの残高を利用してベットする場合、全ゲームのベット額は、賭け条件に対して100％反映されます。
        </p>
        <p class="terms-clause">
          5.2.2&#12288;各プロモーションの規約により対象外ゲーム、禁止ゲームまたは除外ゲームが指定されている場合、これらのゲームでのベットは賭け条件に一切反映されず、当該ゲームでのプレイも禁止されます。
        </p>

        <h3 class="terms-title">
          6. 有効期限
        </h3>
        <h4 class="terms-subtitle">
          6.1 有効期限経過後の取扱い
        </h4>
        <p class="terms-clause">
          6.1.1&#12288;ボーナスまたはフリースピンの有効期限を過ぎた場合、当該ボーナスまたはフリースピンは自動的に失効します。当サイトは、失効したボーナスおよび当該ボーナスに関連する勝利金をアカウントから回収する権利を有します。
        </p>
        <h4 class="terms-subtitle">
          6.2 ボーナス
        </h4>
        <p class="terms-clause">
          6.2.1&#12288;各プロモーションの規約に別段の定めがない限り、BONUSウォレットまたは現金ウォレットに付与されたボーナスの有効期限は、当該ボーナスの付与後30日間です。当該ボーナスに賭け条件が設定されている場合は、同期間内に当該賭け条件を達成する必要があります。
        </p>
        <h4 class="terms-subtitle">
          6.3 フリースピン
        </h4>
        <p class="terms-clause">
          6.3.1&#12288;各プロモーションの規約に別段の定めがない限り、フリースピンの有効期限は付与後7日間です。
        </p>

        <h3 class="terms-title">
          7. 禁止・除外ゲーム
        </h3>
        <h4 class="terms-subtitle">
          7.1 規約違反時の取扱い
        </h4>
        <p class="terms-clause">
          7.1.1&#12288;本規約または各プロモーションの規約により禁止されているゲームまたはサービスを利用した場合、規約違反となります。この場合、当サイトは、すべてのボーナスおよび関連する勝利金を無効とし、没収する権利を有します。
        </p>
        <h4 class="terms-subtitle">
          7.2 BONUSウォレット
        </h4>
        <p class="terms-clause">
          7.2.1&#12288;BONUSウォレット内の残高を利用してベットする場合、次に掲げるゲームまたはサービスの利用は禁止されます。
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(a)&#12288;パチンコ・パチスロ
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(b)&#12288;クラッシュ
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(c)&#12288;ブラックジャック
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(d)&#12288;ルーレット
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(e)&#12288;Evolutionの「ファーストパーソン（First Person）」シリーズ
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(f)&#12288;スポーツ・予測市場
        </p>
        <p class="terms-clause terms-clause-item">
          7.2.1(g)&#12288;「BONUS禁止」マーク付きのゲーム
        </p>
        <h4 class="terms-subtitle">
          7.3 現金ウォレットに付与されるボーナス
        </h4>
        <p class="terms-clause">
          7.3.1&#12288;各プロモーションに適用される禁止・除外ゲームおよびその詳細は、当該プロモーションページまたはオファーメールに掲載される各プロモーションの規約に明示されます。
        </p>
        <h4 class="terms-subtitle">
          7.4 フリースピン
        </h4>
        <p class="terms-clause">
          7.4.1&#12288;各プロモーションの規約に別段の定めがない限り、フリースピンで獲得した勝利金には禁止・除外ゲームの制限はなく、すべてのゲームに利用できます。
        </p>

        <h3 class="terms-title">
          8. ベット額上限
        </h3>
        <h4 class="terms-subtitle">
          8.1 上限超過時の取扱い
        </h4>
        <p class="terms-clause">
          8.1.1&#12288;本規約または各プロモーションの規約に定めるベット額上限を超えてベットした場合、規約違反となります。この場合、当サイトは、すべてのボーナスおよび関連する勝利金を無効とし、没収する権利を有します。
        </p>
        <h4 class="terms-subtitle">
          8.2 BONUSウォレット
        </h4>
        <p class="terms-clause">
          8.2.1&#12288;BONUSウォレット内の残高を利用してベットする場合、1回あたりのベット額上限は次のとおりです。
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(a)&#12288;スロット：625 JPY / 5 USD
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(b)&#12288;ライブカジノ：3,000 JPY / 20 USD
        </p>
        <h4 class="terms-subtitle">
          8.3 現金ウォレットに付与されるボーナス
        </h4>
        <p class="terms-clause">
          8.3.1&#12288;現金ウォレットにボーナスが付与されている場合において、当該現金ウォレットの残高を利用してベットするときは、各プロモーションの規約に別段の定めがない限り、ベット額上限はありません。ベット額上限が設定されている場合は、当該プロモーションページまたはオファーメールに掲載される各プロモーションの規約に明示されます。
        </p>
        <h4 class="terms-subtitle">
          8.4 フリースピン
        </h4>
        <p class="terms-clause">
          8.4.1&#12288;各プロモーションの規約に別段の定めがない限り、フリースピンで獲得した勝利金にベット額上限はありません。ベット額上限が設定されている場合は、当該プロモーションページまたはオファーメールに掲載される各プロモーションの規約に明示されます。
        </p>

        <h3 class="terms-title">
          9. 出金上限
        </h3>
        <h4 class="terms-subtitle">
          9.1 共通事項
        </h4>
        <p class="terms-clause">
          9.1.1&#12288;ボーナスは、各プロモーションの規約に定める賭け条件等を達成することにより、出金可能となります。BONUSウォレットに付与されたボーナスは、当該条件の達成後、現金ウォレットの出金可能残高へ変換されます。また、プロモーションによっては、ボーナス利用時の出金上限が定められる場合があります。
        </p>
        <h4 class="terms-subtitle">
          9.2 ボーナス
        </h4>
        <p class="terms-clause">
          9.2.1&#12288;BONUSウォレットまたは現金ウォレットに付与されたボーナスに適用される出金上限は、当該プロモーションページまたはオファーメールに掲載される各プロモーションの規約に明示されます。
        </p>
        <h4 class="terms-subtitle">
          9.3 フリースピン
        </h4>
        <p class="terms-clause">
          9.3.1&#12288;各プロモーションの規約に別段の定めがない限り、フリースピンで獲得した勝利金に出金上限は設けられていません。出金上限が設定されている場合は、当該プロモーションページまたはオファーメールに掲載される各プロモーションの規約に明示されます。
        </p>

        <h3 class="terms-title">
          10. ボーナス、プロモーションおよび特典の不正利用
        </h3>
        <h4 class="terms-subtitle">
          10.1 適用範囲および調査方針
        </h4>
        <p class="terms-clause">
          10.1.1&#12288;出金申請の処理時に限らず、当サイトは、プロモーションの公正な運営、不正利用の防止および本規約の遵守状況の確認のため、取引履歴、ゲーム履歴、入出金履歴、ウォレット振替履歴その他必要な記録を随時調査することができます。
        </p>
        <p class="terms-clause">
          10.1.2&#12288;現金ウォレットの残高を利用して行われたプレイであっても、当該プレイが、プロモーションへの参加、ボーナスもしくはキャッシュバックの獲得もしくは算定、賭け条件の達成、またはプロモーション付与後の利益の回収と一体として行われた場合、本条の対象となります。
        </p>
        <p class="terms-clause">
          10.1.3&#12288;本条は、当サイトの利用規約に定める詐欺、共謀、低リスクプレイ、ゲーム内価値の操作その他の禁止行為に関する規定を補足するものです。
        </p>
        <h4 class="terms-subtitle">
          10.2 用語の定義
        </h4>
        <p class="terms-clause">
          10.2.1&#12288;「プロモーションの不正利用」とは、本規約または各プロモーションの規約が予定していない方法により、ボーナス、キャッシュバック、フリースピンその他の特典を取得し、維持し、もしくは増加させ、出金可能残高へ変換し、またはこれらに関連する利益を回収する行為をいいます。
        </p>
        <p class="terms-clause">
          10.2.2&#12288;「低リスクベット」とは、単一または一連のベットを通じて、損失、価格変動またはゲーム結果に伴う実質的なリスクを意図的に軽減、相殺し、または他のゲーム、ウォレット、アカウントもしくは取引へ移転しながら、賭け条件の達成またはプロモーション利益の獲得を図る行為をいいます。
        </p>
        <p class="terms-clause">
          10.2.3&#12288;「ゲーム内価値」とは、フリースピン、ボーナスラウンド、CollectもしくはCash Out機能、メーター、ゲージ、ポイント、累積進捗、リスピン、再抽選、ジャックポット進捗、未決済のゲームラウンド、その他後に実行、決済、回収または資金化することができるゲーム上の状態または権利をいいます。
        </p>
        <p class="terms-clause">
          10.2.4&#12288;「関連する勝利金」とは、ボーナスもしくは特典を利用したベット、違反対象となる一連のベットもしくは取引、または違反対象となるゲーム内価値の実行、決済もしくは回収により、直接または実質的に生じた利益をいいます。
        </p>
        <h4 class="terms-subtitle">
          10.3 低リスクベット
        </h4>
        <p class="terms-clause">
          10.3.1&#12288;次の各行為は、低リスクベットまたはプロモーションの不正利用とみなされる場合があります。
        </p>
        <p class="terms-clause terms-clause-item">
          10.3.1(a)&#12288;ルーレットにおける赤および黒、バカラにおけるプレイヤーおよびバンカーその他相反する結果へ同時または連続してベットすることにより、損失リスクを相殺する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.3.1(b)&#12288;単一または複数のゲームにおいて、結果の大部分を実質的にカバーするベット、ヘッジベットその他損失または価格変動を著しく抑える組合せを行う行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.3.1(c)&#12288;一のゲームで高倍率または高額の勝利を得た後、賭け条件を形式的に達成することを主たる目的として、高RTP、低ボラティリティその他損失リスクが相対的に低いゲームへ直ちにまたは反復して移行する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.3.1(d)&#12288;賭け条件への反映率が低いもしくは反映されないゲームで利益またはゲーム内価値を形成した後、反映率が高いゲームへ移行して賭け条件の達成を図る行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.3.1(e)&#12288;複数のゲーム、ウォレット、アカウント、第三者、デバイスまたは決済手段を組み合わせることにより、損失リスクを軽減もしくは相殺し、またはプロモーション利益を移転する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.3.1(f)&#12288;ゲームの賭け条件への反映方法、決済方法、払戻し方法その他の仕組みを利用して、実質的なリスクを負うことなく賭け条件の達成を図る行為
        </p>
        <h4 class="terms-subtitle">
          10.4 ゲーム内価値の蓄積および決済時期の操作
        </h4>
        <p class="terms-clause">
          10.4.1&#12288;次の各行為は、プロモーションの不正利用として禁止します。
        </p>
        <p class="terms-clause terms-clause-item">
          10.4.1(a)&#12288;プロモーション、ボーナスまたはキャッシュバックの付与前に、現金ウォレットの残高を利用してゲーム内価値を形成または蓄積し、当該プロモーション等の付与後にこれを実行、決済、回収または資金化することにより、本来予定されていない利益を得る行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.4.1(b)&#12288;ゲームラウンドまたはゲーム内機能を意図的に完了させず、賭け条件の達成、新たな入金、新たなボーナスもしくはキャッシュバックの付与、ウォレット振替、ボーナスの取消しまたは出金申請の後に完了させる行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.4.1(c)&#12288;ボーナスまたは特典を利用してゲーム内価値を形成した後、当該価値を回収する前にボーナスの取消し、残高の移動、追加の入金または出金申請を行い、その後に当該価値を実行、決済または回収する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.4.1(d)&#12288;資金またはゲーム内価値をゲーム内に隠し、当該資金または価値を考慮せずにボーナス、キャッシュバックその他の特典を取得し、または出金可能な残高を確保した後、これを回収する行為
        </p>
        <h4 class="terms-subtitle">
          10.5 その他の禁止行為
        </h4>
        <p class="terms-clause">
          10.5.1&#12288;次の各行為は、これらに限定されることなく、プロモーションの不正利用または明確な規約違反とみなされます。
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(a)&#12288;複数アカウントの利用、第三者との共謀、名義、デバイス、IPアドレスまたは決済手段の共有により、同一または関連するプロモーションへ重複して参加し、賭け条件を消化し、または利益を得る行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(b)&#12288;ボット、自動化プログラム、外部ソフトウェア、分析ツールその他当サイトが認めていない手段を利用してプロモーション利益を得る行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(c)&#12288;ゲーム、システム、表示、決済、賭け条件またはプロモーション設計上のエラー、遅延、脆弱性または抜け穴を認識しながら利用する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(d)&#12288;VPN、プロキシその他の手段により所在地、IPアドレス、デバイスまたは関連アカウントを隠し、プロモーションへの参加制限を回避する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(e)&#12288;ボーナストリガーその他のゲーム機能の発動条件を意図的に操作し、プロモーション付与前後で損失リスクと利益の発生時期を分離する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(f)&#12288;出金および再入金を反復し、または複数のウォレットもしくは決済手段間で資金を移動することにより、同一もしくは関連する入金ボーナスその他の特典を繰り返し取得する行為
        </p>
        <p class="terms-clause terms-clause-item">
          10.5.1(g)&#12288;特定のお客様に限定されたプロモーション、コード、リンク、フリースピンその他の特典を第三者へ譲渡、共有、販売または利用させる行為
        </p>
        <h4 class="terms-subtitle">
          10.6 違反の判定
        </h4>
        <p class="terms-clause">
          10.6.1&#12288;当サイトは、違反の有無を判断するにあたり、個別のベットのみではなく、ベットの順序、金額、倍率、RTP、ボラティリティ、賭け条件への反映率、ゲーム間の移行時期、ゲーム内価値の形成および回収時期、ボーナスもしくはキャッシュバックの付与時期、入出金およびウォレット振替の履歴、関連アカウント、デバイス、IPアドレス、決済手段、行為の反復性ならびに経済的な結果を含む一連の取引およびプレイを総合的に考慮します。
        </p>
        <p class="terms-clause">
          10.6.2&#12288;特定のゲームを利用した事実、当該ゲームのRTPが高いこと、またはプレイ中にゲームを変更した事実のみをもって、直ちに本条違反と判断するものではありません。
        </p>
        <p class="terms-clause">
          10.6.3&#12288;当サイトは、通常の娯楽目的による単発的なプレイと、賭け条件またはプロモーションの仕組みを意図的に利用する一連の行為とを区別し、合理的な根拠および利用可能な記録に基づいて判断します。
        </p>
        <h4 class="terms-subtitle">
          10.7 調査中の措置
        </h4>
        <p class="terms-clause">
          10.7.1&#12288;当サイトが合理的な根拠に基づき本条違反を疑う場合、調査が完了するまで、ボーナスもしくは特典の付与、利用もしくは出金可能残高への変換、関連する賭けもしくは取引の決済、出金申請、関連資金の移動またはアカウント機能の全部もしくは一部を一時的に制限することができます。
        </p>
        <p class="terms-clause">
          10.7.2&#12288;当サイトは、調査のために必要な説明、本人確認書類、資金源に関する資料、決済手段の確認資料その他の情報の提出を求めることができます。お客様が合理的な期間内に必要な情報を提出しない場合、当サイトは、利用可能な記録に基づき判断することができます。
        </p>
        <h4 class="terms-subtitle">
          10.8 違反確認後の措置
        </h4>
        <p class="terms-clause">
          10.8.1&#12288;違反が軽微であり、不当な利益が生じていないと当サイトが合理的に判断した場合、当サイトは、警告、対象となるベットの賭け条件への不算入、未使用のボーナスもしくは特典の取消し、または追加の賭け条件の設定その他違反の性質および影響に応じた措置を講じることができます。
        </p>
        <p class="terms-clause">
          10.8.2&#12288;違反が故意であり、または不当な利益が生じたと当サイトが合理的に判断した場合、当サイトは、次の措置の全部または一部を講じることができます。
        </p>
        <p class="terms-clause terms-clause-item">
          10.8.2(a)&#12288;未使用のボーナス、キャッシュバック、フリースピンその他の特典を取消し、または既に付与した特典を回収すること
        </p>
        <p class="terms-clause terms-clause-item">
          10.8.2(b)&#12288;ボーナス、特典または違反対象となる一連の行為に関連するベットもしくは取引を取り消し、または無効とすること
        </p>
        <p class="terms-clause terms-clause-item">
          10.8.2(c)&#12288;関連する勝利金を無効とし、アカウント残高から控除すること
        </p>
        <p class="terms-clause terms-clause-item">
          10.8.2(d)&#12288;当該ボーナス、キャッシュバックその他の特典が付与されず、または違反行為が行われなかった場合の状態へアカウント残高を再計算すること
        </p>
        <p class="terms-clause terms-clause-item">
          10.8.2(e)&#12288;保留中の出金申請を取り消し、または再計算後の出金可能残高に基づいて処理すること
        </p>
        <p class="terms-clause terms-clause-item">
          10.8.2(f)&#12288;特定またはすべてのプロモーションへの参加資格を一時的または恒久的に停止すること
        </p>
        <p class="terms-clause">
          10.8.3&#12288;違反が重大、反復的、組織的もしくは詐欺的である場合、または複数アカウント、第三者との共謀、虚偽情報もしくは不正な決済手段が利用された場合、当サイトは、10.8.2に定める措置に加え、当サイトの利用規約に基づき、アカウント機能の制限、アカウントの停止もしくは閉鎖その他必要な措置を講じることができます。
        </p>
        <p class="terms-clause">
          10.8.4&#12288;お客様が適法に入金し、本条違反と直接関係しない入金元本は、本条違反のみを理由として当然に没収されるものではありません。ただし、当該元本が詐欺、第三者決済、支払取消し、違法取引、マネーロンダリングその他の不正行為に関連する場合、または当該ボーナス、キャッシュバックその他の特典が付与されず、もしくは違反行為が行われなかった場合の状態へ残高を戻すために必要な範囲については、この限りではありません。
        </p>
        <h4 class="terms-subtitle">
          10.9 通知および再審査
        </h4>
        <p class="terms-clause">
          10.9.1&#12288;当サイトは、法令、セキュリティ、不正防止または調査上の理由により開示できない場合を除き、違反が確認されたお客様に対し、講じた措置の概要および対象となる資金の算定方法を通知します。
        </p>
        <p class="terms-clause">
          10.9.2&#12288;お客様は、当サイトが指定する期間内にカスタマーサービスへ連絡し、当該判断の再審査を求めることができます。当サイトは、提出された説明および資料を確認し、再審査結果を通知します。
        </p>

        <h3 class="terms-title">
          11. 適用される法律およびその他の規定
        </h3>
        <h4 class="terms-subtitle">
          11.1 準拠法および裁判管轄
        </h4>
        <p class="terms-clause">
          11.1.1&#12288;本規約は、コモロ諸島の法律に準拠します。お客様は、本規約に起因または関連して発生する紛争、論争または申立てについて、コモロ諸島の裁判所の専属管轄に服することに同意するものとします。
        </p>
        <h4 class="terms-subtitle">
          11.2 プロモーション参加資格
        </h4>
        <p class="terms-clause">
          11.2.1&#12288;Lite Playerとしてご登録のお客様は、プロモーションに参加することはできません。
        </p>
        <h4 class="terms-subtitle">
          11.3 本規約の変更
        </h4>
        <p class="terms-clause">
          11.3.1&#12288;当サイトは、重大な変更を含む本規約の内容を、事前の通知なく随時変更する権利を有します。変更後の本規約は、当サイトに掲載された時点で効力を発生いたします。
        </p>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'RuleGold',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/terms-and-conditions'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
<style>
.terms-list {
	font-size: 14.5px;
	line-height: 2;
}
.terms-list ol {
  margin-left: 20px;
}

.terms-list li {
  line-height: 2;
}

.sub-list {
  list-style-type: lower-roman; /* i, ii, iii... */
  margin-top: 12px;
  margin-left: 20px;
}
</style>
<style scoped>
/* 條款結構：章（terms-title）／節（terms-subtitle）／條（terms-clause）／款（terms-clause-item） */
.update-time + .terms-title {
  margin-top: 0;
}
.terms-title {
  margin: 2.5rem 0 1rem;
  font-size: 1.25rem;
  font-weight: 700;
}
.terms-subtitle {
  margin: 1.5rem 0 0.75rem;
  font-size: 1rem;
  font-weight: 700;
}
.terms-clause {
  margin: 0 0 1rem;
  font-size: 1rem;
  line-height: 2;
}
.terms-clause-item {
  padding-left: 1.5em;
}
</style>
